module.exports = __webpack_public_path__ + "img/goal1.54284fb0.svg";